import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Product from "@/pages/Product";
import ModulePage from "@/pages/ModulePage";
import CategoryPage from "@/pages/CategoryPage";
import Solutions from "@/pages/Solutions";
import Pricing from "@/pages/Pricing";
import Resources from "@/pages/Resources";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Security from "@/pages/Security";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import Compare from "@/pages/Compare";
import Contractors from "@/pages/Contractors";
import Library from "@/pages/Library";
import Help from "@/pages/Help";
import HelpArticle from "@/pages/HelpArticle";
import Admin from "@/pages/Admin";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/product" element={<Product />} />
            <Route path="/product/:slug" element={<ModulePage />} />
            <Route path="/platform/:slug" element={<CategoryPage />} />
            <Route path="/features" element={<Navigate to="/product" replace />} />
            <Route path="/features/*" element={<Navigate to="/product" replace />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/compare" element={<Compare />} />
            <Route path="/for-contractors" element={<Contractors />} />
            <Route path="/library" element={<Library />} />
            <Route path="/help" element={<Help />} />
            <Route path="/help/:slug" element={<HelpArticle />} />
            <Route path="/support" element={<Navigate to="/help" replace />} />
            <Route path="/contractors" element={<Navigate to="/for-contractors" replace />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/security" element={<Security />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-center" theme="dark" />
    </div>
  );
}

export default App;
